import { reportService } from "../../helpers/reportService";

export const state = {
  getUserAll:[],
  getAllChargerReport: [],
  getAllUserReport: [],
  chargerReportCount: "",
  userReportCount: "",
  getAllCompletedPayment: [],
  completedPaymentCount: "",
  pagination: {},
  loading: true,
};

export const mutations = {
  getUserAll(state, payload){
    state.getUserAll = payload.result;
  },
  getAllChargerReport(state, payload) {
    state.getAllChargerReport = payload.result.data;
    state.loading = false;
    state.pagination = payload.result;
    state.chargerReportCount = payload.result.total;
  },
  getAllUserReport(state, payload) {
    state.getAllUserReport = payload.result.data;
    state.loading = false;
    state.pagination = payload.result;
    state.userReportCount = payload.result.total;
  },
  getChargerReportListRequest(state) {
    state.loading = true;
  },
  getUserReportListRequest(state) {
    state.loading = true;
  },
  getChargerReport(state, payload) {
    state.user = payload.result;
  },
  getUserReport(state, payload) {
    state.user = payload.result;
  },
  getChargerReportListFailure(state) {
    state.loading = false;
  },
  getUserReportListFailure(state) {
    state.loading = false;
  },
};

export const actions = {
  async getUserAllAction({ dispatch, commit },data){
    let token = JSON.parse(localStorage.getItem("token"));
    window.axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    await reportService.getUserAll(data).then(
      (response) => {
        commit("getUserAll", response.data);
      },
      (error) => {
        dispatch("alert/error", error, { root: true });
      }
    );
  },

  async getChargerReport({ dispatch, commit }, data) {
    let token = JSON.parse(localStorage.getItem("token"));
    window.axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

    commit("getChargerReportListRequest");
    await reportService.getChargerReport(data).then(
      (response) => {
        commit("getAllChargerReport", response.data);
      },
      (error) => {
        commit("getChargerReportListFailure", error, { root: true });
        dispatch("alert/error", error, { root: true });
      }
    );
  },

  async getUserReport({ dispatch, commit }, data) {
    let token = JSON.parse(localStorage.getItem("token"));
    window.axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

    commit("getUserReportListRequest");
    await reportService.getUserReport(data).then(
      (response) => {
        commit("getAllUserReport", response.data);
      },
      (error) => {
        commit("getUserReportListFailure", error, { root: true });
        dispatch("alert/error", error, { root: true });
      }
    );
  },
};

export const getters = {
  loading: (state) => state.loading,
  getAllChargerReport: (state) => state.getAllChargerReport,
  getAllUserReport: (state) => state.getAllUserReport,
  chargerReportCount: (state) => state.chargerReportCount,
  userReportCount: (state) => state.userReportCount,
  pagination: (state) => state.pagination,
  getUserAll:(state) => state.getUserAll,
};
